import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TDeletePushToCardUserCardRequestSchema } from "./deletePushToCardUserCard.schema";

export const deletePushToCardUserCard = (axios: IAxiosInstance) => {
  return async (body: TDeletePushToCardUserCardRequestSchema) => {
    const response = await axios.noRetry.delete(`/push-to-card/card`, {
      data: body,
    });

    return response;
  };
};
